module.exports = __webpack_public_path__ + "static/media/idlepage.3b6f40c6.svg";